import { Component, Input, OnInit } from '@angular/core';
import { PromoCode } from 'app/shared/models/class/discount/discount';
import { DiscountService } from 'app/shared/services/discount/discount.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss']
})
export class DiscountComponent implements OnInit {

  @Input() clubCode: string;

  discounts: PromoCode[];
  discountsActive: PromoCode[];

  constructor(
    private discountService: DiscountService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.getDiscount();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  private getDiscount(): void {
    this.discountService.getPromoCodeByClub(this.clubCode).subscribe({
      next: discounts => {
        this.discounts = discounts;
        const today = new Date();
        this.discountsActive = discounts.filter(d => new Date(d.promoEndDate) >= today);
      }
    });
  }
}
